exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".avatarCircle{width:4rem;height:4rem;border:1px solid #ddd;border-radius:4rem;display:inline-block}.avatarCircle .avatarIcon{width:2.5rem;height:2.5rem;margin:.7rem}.avatarCircle.initial{background-color:#00a0f4;border-color:#00a0f4}.avatarCircle.initial .avatarIcon{font-size:1.2em;color:#fff;text-align:center;margin:.6rem}.avatarCircle .owlConstraints{margin:.2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/icons/avatar_circle.scss
// module id = 1476
// module chunks = 0